// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthAuthorizedApplicationSchema = z.object({
  id: z.number().int().gt(0).describe("Application ID"),
  name: z.coerce.string().min(1).describe("Application name"),
  uid: z.coerce.string().min(1).describe("Application client ID"),
  scopes: z.coerce.string().min(1).describe("Space-separated list of granted scopes"),
  created_at: z.number().int().describe("Authorization created timestamp (Unix timestamp)"),
});
